import { Building2 } from 'lucide-preact'
import { memo } from 'preact/compat'
import type { DashboardWindowCountDto } from '@/types/dashboard'
import { DashboardStatTile } from './DashboardStatTile'

interface CompaniesEngagedStatTileProps {
  count: DashboardWindowCountDto | null | undefined
  rangeLabel?: string
  loading?: boolean
  error?: string | null
  failed?: boolean
}

export const CompaniesEngagedStatTile = memo((props: CompaniesEngagedStatTileProps) => (
  <DashboardStatTile
    titleLines={['Companies', 'Engaged']}
    icon={<Building2 className="w-5 h-5 text-primary-600 dark:text-primary-400" />}
    {...props}
  />
))
